const sendToKlaviyo = async (e, list_id, custom_source, el) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const successMessage = "You're set! Let's fuel up. 🔥";
  const failMessage = "Something went wrong. Please try again.";

  let email = formData.get('email'); //formData.email; //'test@test.com';

  if(!custom_source) custom_source = '';

  try {
    const options = {
      method: 'POST',
      headers: {
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: custom_source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: "SUBSCRIBED"
                      }
                    },
                  }
                }
              }
            },
          },
          relationships: { list: { data: { type: 'list', id: list_id } } },
        }
      })
    };

    //console.log(options);
    const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RSJ53P', options);


    let message = successMessage;

    // success from klaviyo is empty result and 202 status code
    if(!response || response.status != 202) {
      const jsonRes = await response.json();
      console.log("Subscribing Failed", jsonRes);
      message = failMessage;
    }
    
    if(el) {
      el.innerHTML =`<p class="form-response">${message}</p>`;
    }
    return {success: true, message: message}
  } catch (e) {
    console.error('Error sending to Klaviyo:', e);
    
    if(el) {
      el.innerHTML =`<p class="form-response">${failMessage}</p>`;
    }

    return {success: true, message: failMessage};
  }
};
